const setReceipt = (state, receipt) => {
  state.receipt = receipt;
};

export default {
  setReceipt,
};
